import React from 'react'
import { Hidden, Typography } from '@material-ui/core'

export default function Location({ hit }) {
  const facility = (
    <Typography variant="body1" component="span">
      {hit.facility_name}
    </Typography>
  )

  const cityState = (
    <Typography variant="body1" component="span">
      {hit.city}, {hit.state}
    </Typography>
  )

  return (
    <>
      <Hidden xsDown implementation="css">
        {facility} - {cityState}
      </Hidden>

      <Hidden smUp implementation="css">
        <div>{facility}</div>
        <div>{cityState}</div>
      </Hidden>
    </>
  )
}
